<div class="row">
  <div class="col-md-12">
    <section class="panel panel-default">
      <div class="panel-heading clearfix">
        <h3 class="panel-title" aria-controls="collapsedForm">
          Listado de Vacantes
          <a class="btn btn-primary btn-back" (click)="close()">Volver</a>
        </h3>
      </div>

      <div class="panel-body panel-collapse">
        <datatable [columnDefinitions]="columnDefinitions" [data]="tabledata">
        </datatable>
      </div>
    </section>
    <a class="btn btn-primary btn-back" (click)="close()">Volver</a>
  </div>
</div>
